module.exports = __webpack_public_path__ + "static/tat-script1-0f21feea06b879f557f3c97d15ed1933.jpg";